import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { UserRole } from '../models/user/user-role.enum';
import { UnsubscribeOnDestroyAdapter } from '../adapters/unsubscibe-on-destroy.adapter';

/**
 * Add the template content to the DOM unless the condition is true.
 */
@Directive({
  selector: '[pscRoleAccess]',
  exportAs: 'pscRoleAccess',
})
export class RoleAccessDirective extends UnsubscribeOnDestroyAdapter implements OnInit {
  get includeNotLoggedInUsers(): boolean | undefined {
    return this._includeNotLoggedInUsers;
  }

  @Input()
  set includeNotLoggedInUsers(value: boolean | undefined) {
    this._includeNotLoggedInUsers = value;
    this.checkAccess();
  }

  /**
   * Hides or shows navigation item based on if user has roles or not. If roles are undefined that means no role is needed to show (i.e. it will show to everyone)
   * @param roles List of roles.
   */
  @Input() set pscRoleAccess(roles: UserRole[] | undefined) {
    this.roles = roles;
    this.checkAccess();
  }

  private _includeNotLoggedInUsers: boolean | undefined = false;
  roles: UserRole[] | undefined;


  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.authService.getUserDataObservable().subscribe(() => {
      this.checkAccess();
    });
  }

  checkAccess() {
    this.viewContainer.clear();
    if (this._includeNotLoggedInUsers && !this.authService.userLoggedIn()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      return;
    }
    if (this.roles && this.authService.userHasRoles(this.roles)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
